import { c as _c } from "react/compiler-runtime";
import { BottomSheetBody, BottomSheetHeader, BottomSheetHeaderTitle, classNames, Flex, FlexColumn, ItemContent, ItemDescription, ItemSide, ItemTitle, Separator, SkeletonBlock, TextBody } from "@opensea/ui-kit";
import { useTranslations } from "use-intl";
import { ActionTimelineSkeleton } from "../../../components/ActionTimeline";
import { Item } from "../../../components/Item";
export function CheckoutFlowSkeleton(t0) {
  const $ = _c(34);
  const {
    count,
    isClaim
  } = t0;
  const t = useTranslations("wallet.CheckoutFlow");
  let t1;
  if ($[0] !== isClaim || $[1] !== t) {
    t1 = isClaim ? t("claimTitle") : t("title");
    $[0] = isClaim;
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <BottomSheetHeaderTitle>{t1}</BottomSheetHeaderTitle>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== isClaim || $[6] !== t) {
    t3 = isClaim && <TextBody className="mt-1 text-text-secondary" size="sm">{t("claimSubtext")}</TextBody>;
    $[5] = isClaim;
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <BottomSheetHeader><Flex className="flex-col">{t2}{t3}</Flex></BottomSheetHeader>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== count) {
    t5 = new Array(count).fill(0).map(_temp);
    $[11] = count;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t5) {
    t6 = <FlexColumn className="max-h-36 overflow-y-auto">{t5}</FlexColumn>;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== isClaim || $[16] !== t) {
    t7 = !isClaim && <><Separator className="my-2" /><Item className="py-4" variant="unstyled"><ItemContent><ItemTitle>{t("total")}</ItemTitle></ItemContent><ItemSide className="items-end"><ItemTitle><SkeletonBlock className="h-4 w-16" /></ItemTitle><ItemDescription className="mt-1.5"><SkeletonBlock className="h-4 w-10" /></ItemDescription></ItemSide></Item></>;
    $[15] = isClaim;
    $[16] = t;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t6 || $[19] !== t7) {
    t8 = <FlexColumn className="w-full">{t6}{t7}</FlexColumn>;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Separator className="hidden h-auto md:block" orientation="vertical" />;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== isClaim || $[23] !== t) {
    t10 = !isClaim && <><TextBody className="mb-4 uppercase" color="text-secondary" size="xs" weight="semibold">{t("paymentMethod")}</TextBody><SkeletonBlock className="h-20 w-full rounded" /><Separator className="my-6" /></>;
    $[22] = isClaim;
    $[23] = t;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <ActionTimelineSkeleton count={1} />;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t10) {
    t12 = <FlexColumn className="w-full min-w-0">{t10}{t11}</FlexColumn>;
    $[26] = t10;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== t12 || $[29] !== t8) {
    t13 = <BottomSheetBody><Flex className="size-full flex-col gap-10 md:flex-row">{t8}{t9}{t12}</Flex></BottomSheetBody>;
    $[28] = t12;
    $[29] = t8;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== t13 || $[32] !== t4) {
    t14 = <>{t4}{t13}</>;
    $[31] = t13;
    $[32] = t4;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  return t14;
}
function _temp(_, i) {
  return <Item className="py-4" key={i} variant="unstyled"><SkeletonBlock className={classNames("order-1 size-12 shrink-0 rounded text-text-primary")} /><ItemContent><ItemTitle><SkeletonBlock className="h-4 w-16" /></ItemTitle></ItemContent><ItemSide className="items-end"><ItemTitle><SkeletonBlock className="h-4 w-16" /></ItemTitle><ItemDescription className="mt-1.5"><SkeletonBlock className="h-4 w-10" /></ItemDescription></ItemSide></Item>;
}